import styles from './contact.module.scss';

const Contact: React.FC = () => {
  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        <li>
          <a href="tel:+420601360360" className={styles.link}>
            +420 601 360 360
          </a>
        </li>
        <li>
          <a href="mailto:info@360pizza.com" className={styles.link}>
            info@360pizza.com
          </a>
        </li>
        <li>
          <a href="mailto:zakaznici@360pizza.com" className={styles.link}>
            zakaznici@360pizza.com
          </a>
        </li>
      </ul>
      <div className={styles.address}>
        <address>
          Crocodille ČR, spol. s. r. o. <br />
          Poděbradská 206/57, 198 00 Praha 9 <br />
          IČO: 43001343
        </address>
        <p>
          společnost zapsaná v obchodním rejstříku vedeném Městským soudem v
          Praze, oddíl C, vložka 166961
        </p>
      </div>
    </div>
  );
};

export default Contact;
